import { Link } from "react-router-dom";
import { House } from "@/components/house/House";
import { KiEinsatz } from "@/components/house/KiEinsatz";

/**
 * Architektur — die Landkarte der Plattform, ohne Ziele.
 *
 * Die Umsetzungsziele (`CONUT-…`) standen hier als Marker am Knoten und als
 * Chip im Dialog. Sie sind auf die Seite „Umsetzungsgrad" gezogen, die dieselbe
 * Übersicht zeigt (`<House goals />`) — hier stören sie beim Lesen der
 * Architektur. Der Verweis unten hält den Weg dorthin offen.
 */
export function ArchitecturePage() {
  return (
    <div className="page page--lanes">
      <div className="page-header">
        <h2 className="page-title">Architecture</h2>
        <div className="page-subtitle">
          Sechs Bahnen von den externen Quellen bis ins Deployment — Form = Bauzustand.
          Klicke eine Komponente für Details und Drill-Down in Artefakte/Runs. Ziele,
          Zieldaten und Zielstatus stehen auf <Link to="/umsetzungsgrad">Umsetzungsgrad</Link>.
        </div>
      </div>
      <House />
      <div style={{ marginTop: 28 }}>
        <KiEinsatz />
      </div>
    </div>
  );
}
